import { DeviceProfile, mapModelToDeviceProfile } from 'app/features/settings/models';
import { ProductBox } from 'app/shared/components/product-box/models/product-box';
import { Activity, defaultActivity } from 'app/shared/features/activity-selector/models/activity';
import { Batch } from 'app/shared/features/batch-selector/models';
import { Container, mapModelToContainer } from 'app/shared/features/container-selector/models/container';
import { Employee } from 'app/shared/features/employee-selector/models/employee';
import { Locations, mapModelToLocations } from 'app/shared/features/location-selector/models/locations';
import {
    GreenHouseMap,
    mapModelToGreenHouseMap,
} from 'app/shared/features/map-row-selector/models/green-house-map';
import { MasterDataModel } from 'app/shared/models/master-data-model';

export const mapModelToMasterData = (model: MasterDataModel): MasterData => {
    const defaultActivityInstance = defaultActivity();
    const activities = model.activities.map((a): Activity => ({ ...defaultActivityInstance, ...a }));
    const batches = model.batches?.map((b): Batch => ({ ...b })) ?? [];
    const containers = model.containers.map(mapModelToContainer);
    const employees = model.employees.map((e): Employee => ({ ...e }));
    const maps = model.maps.map(mapModelToGreenHouseMap);
    const productBoxes = model.productBoxes?.map((p): ProductBox => ({ ...p })) ?? [];
    const locations = model.locations.map(mapModelToLocations);
    const deviceProfile = mapModelToDeviceProfile(model.deviceProfile);

    return {
        activities,
        batches,
        employees,
        containers,
        maps,
        date: Date.now(),
        productBoxes,
        locations,
        deviceName: model.deviceName,
        deviceProfile,
    };
};

export interface MasterData {
    activities: Activity[];
    batches?: Batch[];
    containers: Container[];
    date: number;
    employees: Employee[];
    maps: GreenHouseMap[];
    productBoxes: ProductBox[];
    locations: Locations[];
    deviceName: string;
    deviceProfile: DeviceProfile | null;
}
